<template>
  <div class="duration-editor">
    <span class="duration-editor__trigger">
      <time-decimal-picker
        :value="current"
        @change="handleCurrentChange"
        size="small"
        :max="duration"
      />
      {{ formatProgress(current) }}
    </span>
    /
    <span class="duration-editor__trigger">
      <time-decimal-picker
        :value="duration"
        @change="handleTimeChange"
        size="small"
        :disabledMinutes="disabledMinutes"
        :disabledSeconds="disabledSeconds"
        :min="1e3"
        :max="3e5"
      />
      {{ formatProgress(duration) }}&ensp;
      <a-icon type="edit" />
    </span>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import { formatTimeInterval } from '../../utils';
import TimeDecimalPicker from '../base/TimeDecimalPicker';

export default {
  props: ['current', 'duration'],
  components: {
    TimeDecimalPicker
  },
  model: {
    prop: 'duration',
    event: 'change'
  },
  computed: {
    ...mapGetters(['activeFragment']),
    ...mapState(['effects'])
  },
  methods: {
    formatProgress: formatTimeInterval,
    handleTimeChange: function (e) {
      this.$emit('change', e);
    },
    handleCurrentChange(e) {
      this.$emit('update:current', e);
    },
    disabledMinutes() {
      const ret = [];
      for (let i = 6; i < 60; i++) {
        ret.push(i);
      }
      return ret;
    },
    disabledSeconds(_, minutes) {
      const ret = [];
      if (minutes === 0) {
        // return [0, 1, 2];
        return [0];
      }
      if (minutes === 5) {
        for (let i = 1; i < 60; i++) {
          ret.push(i);
        }
      }
      return ret;
    }
  }
}
</script>
<style>
.duration-editor {
  position: absolute;
  right: 200px;
  top: 8px;
  bottom: 0;
  padding-left: 12px;
  display: flex;
  align-items: center;
  font-weight: 600;
  overflow: hidden;
  border: 8px solid transparent;
  border-top: 0;
}

.duration-editor__trigger {
  display: inline-block;
  transition: 0.2s;
  box-shadow: 0 25px 0 -24px transparent;
  position: relative;
  margin-top: -29px;
  padding-top: 29px;
}

.duration-editor__trigger:hover {
  box-shadow: 0 1px rgba(0, 0, 0, 0.3);
}

.duration-editor .ant-time-picker {
  width: 100%;
  position: absolute;
  right: 0;
  bottom: -1px;
  opacity: 0;
}

.duration-editor .ant-time-picker-clear {
  display: none;
}
</style>
